import { copyRichTextToClipboard } from '@openx/utils/lib/copyToClipboard';
import type { Components } from 'react-markdown';
import type { TroubleshootingMessage } from '../components/FeedbackMessageActions/FeedbackMessageActions';
import { getTroubleshootingClipboardContent } from './getTroubleshootingClipboardContent';

export const copyTroubleshootingMessage = async (message: TroubleshootingMessage, components: Components = {}) => {
  const clipboardContent = await getTroubleshootingClipboardContent(message, components);

  await copyRichTextToClipboard(clipboardContent);
};
